export const joiErrorMessage = (element) => {
  return element.length > 0 ? element.map((err) => err.$message).join(",") : "";
};
